import Facebook from "../assets/social-media-icons/facebook_32x32.png";
import Twitter from "../assets/social-media-icons/twitter_32x32.png";
import Email from "../assets/social-media-icons/email_32x32.png";
import {Box, Button, Flex, Image, Link, Spacer, HStack} from '@chakra-ui/react';

const KascadeTitle = () => {
  return (
    <div className="flex justify-center  my-10 gap-7">
      

      <Flex //className=" rounded-full bg-deep-blue"



       justify = "space-around" width = "70%" >
        
          <a
            className="hover:opacity-50 transition duration-500"
            href="https://mobile.twitter.com/nervedrip"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="kascade-title" src="../assets/kascade-Lettered-White.png" />
          </a>
         
      </Flex>

      

      
    </div>

  );
};

export default KascadeTitle;
